import React from 'react';
import {defaultMemoize} from 'reselect';
import PropTypes from 'prop-types';

class Memoize extends React.Component {
  static propTypes = {
    memoizeFn: PropTypes.func.isRequired,
    children: PropTypes.func.isRequired,
  };

  state = {originalMemoizeFn: () => null, memoizeFn: () => null};

  static getDerivedStateFromProps({memoizeFn}, {originalMemoizeFn}) {
    return originalMemoizeFn === memoizeFn
      ? null
      : {
          originalMemoizeFn: memoizeFn,
          memoizeFn: defaultMemoize(memoizeFn),
        };
  }

  render() {
    return this.props.children(this.state.memoizeFn(this.props));
  }
}

export default Memoize;
